import { render, staticRenderFns } from "./Algolia.vue?vue&type=template&id=15e518e8&scoped=true&"
import script from "./Algolia.vue?vue&type=script&lang=js&"
export * from "./Algolia.vue?vue&type=script&lang=js&"
import style0 from "./Algolia.vue?vue&type=style&index=0&id=15e518e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e518e8",
  null
  
)

export default component.exports